import alt from 'components/Dispatcher';
import immutableStore from 'utils/immutableStore';
import {Record} from 'immutable';
import ManagerCoachingEffectivenessActions from 'actions/dashboard/ManagerCoachingEffectivenessActions';

@immutableStore
class ManagerCoachingEffectivenessStore {
  constructor() {
    this.state = Record({
      widgetLoading: false,
      widgetError: false,
      widget: undefined,
    })();
    this.bindActions(ManagerCoachingEffectivenessActions);
  }

  getCoachingEffectivenessReportLoading() {
    this.setState({
      widgetLoading: true,
      widgetError: false,
      widget: undefined,
    });
  }

  getCoachingEffectivenessReportSuccess(widget) {
    this.setState({
      widgetLoading: false,
      widgetError: false,
      widget,
    });
  }

  getCoachingEffectivenessReportError(error) {
    this.setState({
      widgetLoading: false,
      widgetError: true,
      widget: undefined,
    });
  }
}

export default alt.createStore(ManagerCoachingEffectivenessStore);
